import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, List, ListItem } from "@mui/material";

// Shown when saving changes to an already-live order (status 'modifying')
// would send new items to the kitchen — a line added this visit, or an
// existing line's quantity raised past what's already been printed. Names
// exactly what's about to print so the guest confirms before it's sent.
export default function KotConfirmDialog({ open, items, onCancel, onConfirm }) {
  return (
    <Dialog open={open} onClose={onCancel} fullWidth maxWidth="xs">
      <DialogTitle>Send new items to the kitchen?</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          These items will be sent to the kitchen:
        </Typography>
        <List dense sx={{ py: 0 }}>
          {(items || []).map((item, i) => (
            <ListItem key={i} sx={{ py: 0.25, px: 0, display: "list-item", listStyleType: "disc", ml: 2.5 }}>
              <Typography variant="body2">
                {item.name} × {item.qty}
              </Typography>
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button variant="contained" onClick={onConfirm}>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}
